"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _rcSlider = _interopRequireDefault(require("rc-slider"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _reactEasyCrop = _interopRequireDefault(require("react-easy-crop"));

var _canvasHelpers = require("../../utils/canvasHelpers");

var _Button = _interopRequireDefault(require("../Button/Button"));

var _Flex = _interopRequireDefault(require("../Flex/Flex"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _Modal = _interopRequireDefault(require("../Modal/Modal"));

var _ImageCropModalStyles = _interopRequireDefault(require("./ImageCropModalStyles"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable react/jsx-props-no-spreading */
var CropInterface = function CropInterface(_ref) {
  var imageToCrop = _ref.imageToCrop,
      saveCroppedImage = _ref.saveCroppedImage,
      imageName = _ref.imageName,
      cancelCrop = _ref.cancelCrop,
      aspectRatio = _ref.aspectRatio;
  var initialZoom = 1;
  var initialRotate = 0;
  var minZoom = 0.1;
  var maxZoom = 5;

  var _useState = (0, _react.useState)(1),
      zoom = _useState[0],
      setZoom = _useState[1];

  var _useState2 = (0, _react.useState)({
    x: 0,
    y: 0
  }),
      crop = _useState2[0],
      setCrop = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      croppedAreaPixels = _useState3[0],
      setCroppedAreaPixels = _useState3[1];

  var _useState4 = (0, _react.useState)(initialRotate),
      rotation = _useState4[0],
      setRotation = _useState4[1];

  var onCropComplete = (0, _react.useCallback)(function (croppedArea, croppedAreaPixelsDimensions) {
    setCroppedAreaPixels(croppedAreaPixelsDimensions);
  }, []);
  var beginSaveCroppedImage = (0, _react.useCallback)( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var croppedImage;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return (0, _canvasHelpers.getCroppedImg)(imageToCrop, croppedAreaPixels, rotation, imageName);

          case 3:
            croppedImage = _context.sent;
            saveCroppedImage(croppedImage);
            _context.next = 10;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            console.error(_context.t0);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  })), [imageToCrop, croppedAreaPixels, rotation]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_ImageCropModalStyles["default"], null), /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    flexDirection: "column",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    width: "100%",
    style: {
      position: "relative"
    },
    height: ["calc(100% - 120px)", "calc(100% - 150px)"]
  }, /*#__PURE__*/_react["default"].createElement(_reactEasyCrop["default"], {
    image: imageToCrop,
    crop: crop,
    zoom: zoom,
    minZoom: minZoom,
    maxZoom: maxZoom,
    rotation: rotation,
    restrictPosition: false,
    aspect: aspectRatio,
    onCropChange: setCrop,
    onCropComplete: onCropComplete,
    onZoomChange: setZoom
  })), /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    flexDirection: "column",
    p: [2, 3],
    justifyContent: "space-between",
    height: ["120px", "150px"]
  }, /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    name: "remove",
    mr: 2,
    color: "primary.0",
    size: 24
  }), /*#__PURE__*/_react["default"].createElement(_rcSlider["default"], {
    min: minZoom,
    max: maxZoom,
    step: 0.1,
    value: zoom,
    defaultValue: initialZoom,
    onChange: function onChange(zoomValue) {
      return setZoom(zoomValue);
    }
  }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    name: "add",
    ml: 2,
    color: "primary.0",
    size: 24
  })), /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    name: "rotate_left",
    mr: 2,
    color: "primary.0",
    size: 24
  }), /*#__PURE__*/_react["default"].createElement(_rcSlider["default"], {
    min: -180,
    max: 180,
    step: 1,
    value: rotation,
    defaultValue: initialRotate,
    onChange: function onChange(rotationValue) {
      return setRotation(rotationValue);
    }
  }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    name: "rotate_right",
    ml: 2,
    color: "primary.0",
    size: 24
  })), /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    justifyContent: "space-between"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    elevation: 0,
    color: "primary.0",
    bg: "light.0",
    onClick: cancelCrop,
    width: 100
  }, "Cancel"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    width: 130,
    onClick: beginSaveCroppedImage,
    color: "primary.0"
  }, "Save")))));
};

var appRoot = function appRoot() {
  return typeof document !== "undefined" && document.getElementById("root");
};
/**
 * A modal interface for cropping / rotating images
 *
 * To learn more about how to use this component, see examples within Storybook.
 *
 * @param {object} props React components passed in props
 * @param {function} [props.cancelCrop] Called when a user clicks off the modal or clicks cancel
 * @param {object} [props.imageToCrop] A image file
 * @param {function} [props.saveCroppedImage] Called once a user has edited the image and clicked the 'Save' button
 * @param {string} [props.imageName] Desired file name of image
 * @param {number} [props.aspectRatio] Lock aspect ratio of output image
 */


var ImageCropModal = function ImageCropModal(_ref3) {
  var cancelCrop = _ref3.cancelCrop,
      imageToCrop = _ref3.imageToCrop,
      saveCroppedImage = _ref3.saveCroppedImage,
      imageName = _ref3.imageName,
      _ref3$aspectRatio = _ref3.aspectRatio,
      aspectRatio = _ref3$aspectRatio === void 0 ? 1 / 1 : _ref3$aspectRatio,
      props = _ref3.props;
  return /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react["default"].createElement(_Modal["default"], (0, _extends2["default"])({
    bg: "light.0",
    onToggle: function onToggle() {
      cancelCrop();
    },
    flexDirection: "column",
    disableScrollbar: true,
    animated: true,
    width: "90vw",
    height: "80vh",
    mb: 100,
    alignItems: "center"
  }, props), /*#__PURE__*/_react["default"].createElement(CropInterface, {
    cancelCrop: cancelCrop,
    imageToCrop: imageToCrop,
    aspectRatio: aspectRatio,
    saveCroppedImage: saveCroppedImage,
    imageName: imageName
  })), appRoot());
};

var _default = ImageCropModal;
exports["default"] = _default;